/*
 * Human-made content badge.
 *
 * The badge adopts the tenant BRAND colour (theme `palette.primary`) so it reads
 * as part of each tenant's identity. Because it is a trust mark that must stay
 * legible on every tenant — pale, dark or highly saturated — the brand colour is
 * run through the same accessibility-safe contrast mechanism the primary Button
 * uses; see colors.js (`getBadgeColors`) and theme/palette/helpers
 * (`getSufficientContrast`). Only the constants below are static.
 *
 * BRAND_INDIGO is the product default brand and is used solely as the seal's
 * standalone fallback when the seal is rendered without a palette colour — in
 * the real placements the banner passes the brand-derived, contrast-checked
 * colour instead. BRAND_WHITE is the seal's foreground and is intentionally kept
 * white: the mechanism darkens the surface behind it, never the text/icon.
 */
export const BRAND_INDIGO = '#5D5BED'
export const BRAND_WHITE = '#FFFFFF'

// SVG needs a concrete font stack; the ring/label are a stylised stamp, kept in
// the brand face rather than the tenant typography ramp.
export const FONT = "'Roboto','Helvetica','Arial',sans-serif"
